import React from 'react';
import { ClassificacaoIbsCbsProvider } from './context/classificacaoIbsCbsContext';
import { ClassificacaoIbsCbsContent } from './classificacaoIbsCbsContent';

export const ClassificacaoIbsCbs: React.FC = () => {
  return (
    <ClassificacaoIbsCbsProvider>
      <ClassificacaoIbsCbsContent />
    </ClassificacaoIbsCbsProvider>
  );
};
